module.exports = {
    Defalt_Theme: {
        sidebarBackground: "#4C4D4F",
        sidebarBorder: "#5C6067",
        sidebarTransparency: "#474646",
        activeTabList: "#3D3F44",
        tabIcon: "#C4C4C5",
        activeIcon: "#FFFFFF",
        logoBackground: "#FFFFFF",
        headerBackground: "#FFFFFF",
        headerIcon: "#696F7B"
    },
    Blue_Theme: {
        "activeIcon": "#f5f5f5",
        "sidebarTransparency": "#17416b",
        "logoBackground": "#ffffff",
        "sidebarBackground": "#1c4e80",
        "activeTabList": "#0091d5",
        "headerBackground": "#ffffff",
        "sidebarBorder": "#235c94",
        "tabIcon": "#a5d8dd",
        "headerIcon": "#1c4e80"
    }
}